import { useEffect, useState } from "react";

export const useTimer = ({ seconds, interval }) => {
    const [timeoutSeconds, setTimeoutSeconds] = useState(seconds);
    const [timer, setTimer] = useState(null);
    
    const start = () => {
        if (timer) clearInterval(timer);
        let timerSeconds = timeoutSeconds;
        const timerInterval = setInterval(() => {
            timerSeconds -= interval;
            setTimeoutSeconds(timerSeconds);
        }, [interval]);
        setTimer(timerInterval);
    }
    
    const clear = () => {
        if (timer) {
            clearInterval(timer);
            setTimer(null);
            setTimeoutSeconds(seconds);
        }
    }
    
    useEffect(() => {
        if (timeoutSeconds <= 0) {
            if (timer) {
                clearInterval(timer);
                setTimer(null);
            }
        }
    }, [timeoutSeconds]);
    
    return [timeoutSeconds, start, clear];
}